export enum EMessageLevel {
	INFO, WARNING, ERROR, SUCCESS, FREESTYLE
}
